// import "./Header.css";


// function Header() {
//   return (
//     <div>
//      <div class="nav">
//         <input type="checkbox" id="nav-check"></input>
//         <div class="nav-header">
//           <div class="nav-title">
//             MysteryCode
//           </div>
//         </div>
//         <div class="nav-btn">
//           <label for="nav-check">
//             <span></span>
//             <span></span>
//             <span></span>
//           </label>
//         </div>
        
//         <div class="nav-links">
//             <ul>
//           <li><a href="#" target="_blank">Home</a></li>
//           <li><a href="#" target="_blank">About</a></li>
//           <li><a href="#" target="_blank">Services</a></li>
//           <li><a href="#" target="_blank">Portfolio</a></li>
//           <li><a href="#" target="_blank">Contact</a></li>
         
//             </ul>
//         </div>
//       </div> </div>
//   );
// }

// export default Header;


import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from '../pics/logo.png'
function Header() {

  // const [scrolled,setScrolled]=React.useState(false);
  // const handleScroll=() => {
  //     const offset=window.scrollY;
  //     if(offset > 100 ){
  //       setScrolled(true);
  //     }
  //     else{
  //       setScrolled(false);
  //     }
  //   }
  
  //   useEffect(() => {
  //     window.addEventListener('scroll',handleScroll)
  //   })
  // let navbarClasses=[''];
  //   if(scrolled){
  //     navbarClasses.push('sticky');
  //   }


  const [active, setActive] = useState("nav__menu");
  const [icon, setIcon] = useState("nav__toggler");
  const navToggle = () => {
    if (active === "nav__menu") {
      setActive("nav__menu nav__active");
    } else setActive("nav__menu");

    // Icon Toggler
    if (icon === "nav__toggler") {
      setIcon("nav__toggler toggle");
    } else setIcon("nav__toggler");
  };   // className={navbarClasses.join(" ")}
  return (
    <div >
    <nav  className="nav">   
      
      {/* <a href="#" className="nav__brand">
        <img className="logo" src={logo}></img>
        Ankit Kumar
      </a> */}
      <ul className={active}>
        <li className="nav__item borderXwidth">
          <a href="#home" className="nav__link">
          Home
          </a>
        </li>
        <li className="nav__item borderXwidth">
          <a href="#" className="nav__link">
            About
          </a>
        </li>
        <li className="nav__item borderXwidth">
          <a href="#" className="nav__link">
            Skills
          </a>
        </li>
        <li className="nav__item borderXwidth">
          <a href="#" className="nav__link">
            Projects
          </a>
        </li>
        <li className="nav__item borderXwidth">
          <a href="#" className="nav__link">
            Contact
          </a>
        </li>
      </ul>
      <div onClick={navToggle} className={icon}>
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
      </div>
    </nav>
    </div>
  );
}

export default Header;